var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompareArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_2392",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_2392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 19.4902L6.94625 18.4212L9.78075 15.5865H2.5V14.0865H9.78075L6.94625 11.252L8 10.1828L12.6538 14.8365L8 19.4902ZM16 13.8077L11.3463 9.15375L16 4.5L17.0538 5.56925L14.2193 8.404H21.5V9.90375H14.2193L17.0538 12.7385L16 13.8077Z",
    fill: "#181717"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareArrows);
export default __webpack_public_path__ + "static/media/compare_arrows.1fa38de8306161a2a3f2f7570fd031b6.svg";
export { ForwardRef as ReactComponent };